import React, { useEffect } from 'react';
import { sendTrackingInfo } from '@panel/commons';

function FreemiumFlowDraftToOn(props) {
  const { isComplete, hasAvailableItems, isInmobiliaria, postingId } = props;
  const siteId = process.env.REACT_APP_BUILD_SITE;
  const newLocation = ['UBPE', 'DVPE', 'ZPAR', '24MX', 'IWBR', 'WIBR', 'PLEC', 'CAPA'].includes(siteId)
    ? `/panel/publicador/principales/operacionypropiedad?postingId=${postingId}`
    : `#`;
  const temporalRedirect = () => {
    window.location = newLocation;
  };

  useEffect(() => {
    const txt = `Publicar Aviso con Datos ${isComplete ? 'completos_' : 'incompletos_'}${
      hasAvailableItems ? 'con credito_' : 'sin credito_'
    }${isInmobiliaria ? 'Inmobiliaria' : 'Particular'}-Intencion`;
    sendTrackingInfo('Mis avisos', txt);
    temporalRedirect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <></>;
}

export { FreemiumFlowDraftToOn };
